module.exports = __webpack_public_path__ + "static/link1.png";